import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

import Home          from "../../pages/Home";
import Services      from "../../pages/Services";
import Plans         from "../../pages/Plans";
import Blogs         from "../../pages/Blogs";
import Contact       from "../../pages/Contact";
import Login         from "../../pages/Login";
import Aboutus       from "../../pages/About-us";
import Signup        from "../../pages/Signup";
import BookService   from "../../pages/Bookservice";
import MyBookings    from "../../pages/Mybookings";
import MySubscription from "../../pages/Mysubscription";
import LearnMore from "../../pages/Learnmore";


import SurveyStep      from "../../pages/SurveyStep";
import SurveyAccordion from "../../pages/SurveyAccordion";
import SurveyDone      from "../../pages/SurveyDone";

import Admin_dashboard        from "../../admin-components/Admin-dashboard";
import Users                  from "../../admin-components/Users";
import Subscriptions          from "../../admin-components/Subscriptions";
import Revenue                from "../../admin-components/Revenue";
import Reports                from "../../admin-components/Reports";
import AdminBookings          from "../../admin-components/AdminBookings";
import AdminServiceAnalytics  from "../../admin-components/AdminServiceAnalytics";
import AdminFeedback          from "../../admin-components/Adminfeedback";
import AdminContacts          from "../../admin-components/Admincontacts";
import TermsAndPolicies       from "../../pages/TermsAndPolicies";

const ADMIN_ROLES = ["admin", "super_admin"];
const USER_ROLES  = ["user", "admin", "super_admin"];

function Wrap({ roles, children }) {
  return <ProtectedRoute allowedRoles={roles}>{children}</ProtectedRoute>;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* ── Public ── */}
      <Route path="/"           element={<Home />} />
      <Route path="/services"   element={<Services />} />
      <Route path="/plans"      element={<Plans />} />
      <Route path="/blogs"      element={<Blogs />} />
      <Route path="/contact"    element={<Contact />} />
      <Route path="/about-us"   element={<Aboutus />} />
      <Route path="/login"      element={<Login />} />
      <Route path="/signup"     element={<Signup />} />
      <Route path="/terms"      element={<TermsAndPolicies />} />
      <Route path="/learnmore" element={<LearnMore />} />



      {/* ── User protected ── */}
      <Route path="/book-service"   element={<Wrap roles={USER_ROLES}><BookService /></Wrap>} />
      <Route path="/my-bookings"    element={<Wrap roles={USER_ROLES}><MyBookings /></Wrap>} />
      <Route path="/my-subscription"element={<Wrap roles={USER_ROLES}><MySubscription /></Wrap>} />
      <Route path="/survey/:slug"           element={<Wrap roles={USER_ROLES}><SurveyStep /></Wrap>} />
      <Route path="/survey/:slug/accordion" element={<Wrap roles={USER_ROLES}><SurveyAccordion /></Wrap>} />
      <Route path="/survey/:slug/done"      element={<Wrap roles={USER_ROLES}><SurveyDone /></Wrap>} />

      {/* ── Admin protected ── */}
      <Route path="/admin/dashboard"        element={<Wrap roles={ADMIN_ROLES}><Admin_dashboard /></Wrap>} />
      <Route path="/admin/users"            element={<Wrap roles={ADMIN_ROLES}><Users /></Wrap>} />
      <Route path="/admin/subscriptions"    element={<Wrap roles={ADMIN_ROLES}><Subscriptions /></Wrap>} />
      <Route path="/admin/revenue"          element={<Wrap roles={ADMIN_ROLES}><Revenue /></Wrap>} />
      <Route path="/admin/reports"          element={<Wrap roles={ADMIN_ROLES}><Reports /></Wrap>} />
      <Route path="/admin/bookings"         element={<Wrap roles={ADMIN_ROLES}><AdminBookings /></Wrap>} />
      <Route path="/admin/service-analytics"element={<Wrap roles={ADMIN_ROLES}><AdminServiceAnalytics /></Wrap>} />
      <Route path="/admin/feedback"         element={<Wrap roles={ADMIN_ROLES}><AdminFeedback /></Wrap>} />
      <Route path="/admin/contacts"         element={<Wrap roles={ADMIN_ROLES}><AdminContacts /></Wrap>} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}